import { render } from "./QA.vue?vue&type=template&id=27e1d3fa&scoped=true&ts=true"
import script from "./QA.vue?vue&type=script&lang=ts"
export * from "./QA.vue?vue&type=script&lang=ts"

import "./QA.vue?vue&type=style&index=0&id=27e1d3fa&scoped=true&lang=scss"
import "./QA.vue?vue&type=style&index=1&id=27e1d3fa&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e1d3fa"]])

export default __exports__